<div class="main-container">
  <div class="container">
    <div class="header">
      <img class="img-fluid" src="./assets/images/banner.png"/>
    </div>
    <div class="form-container">
      <form>
        <div>
          <p>Complete the details below to register to attend the 2024 Western Sydney Diabetes MASTERCLASS SERIES. This event is being held on myINTERACT.</p>

          <p>You have the option to register for</p>

          <ul>
            <li>Virtual event, Tuesdays 17th September to 12th November 7pm</li>
          </ul>

          <p>If you already have a myINTERACT account, enter your existing password below. If not, please complete the fields below and create a myINTERACT password. Once complete, click REGISTER at the bottom of the page to submit.</p>
          <p>If you are having trouble filling out this form, please ensure you are using Chrome as your browser.</p>
        </div>
        <div>
          <h2 class="heading">Registration form</h2>
          <hr><br>
        </div>

        <div class="form-item">
          <label for="Title" class="marg-top-small">Title*</label>
          <select [(ngModel)]="registrationForm.title" id="Title" name="Title" class="dropdownz form-control">
            <option value="" selected="" disabled="">Please select</option>
            <option value="7">Dr</option>
            <option value="8">Associate Prof</option>
            <option value="9">Prof</option>
            <option value="1">Mr</option>
            <option value="2">Mrs</option>
            <option value="5">Ms</option>
            <option value="4">Miss</option>
            <option value="3">Mx</option>
            <option value="6">Mstr</option>
          </select>
        </div>

        <div class="form-item">
          <label for="FirstName" class="marg-top-small">First name*</label>
          <input [(ngModel)]="registrationForm.firstName" type="text" id="FirstName" name="FirstName" maxlength="50" class="form-control" value="">
        </div>

        <div class="form-item">
          <label for="LastName" class="marg-top-small">Last name*</label>
          <input [(ngModel)]="registrationForm.lastName" type="text" id="LastName" name="LastName" maxlength="50" class="form-control" value="">
        </div>

        <div class="form-item">
          <label for="Email" class="marg-top-small">Email*</label>
          <input [(ngModel)]="registrationForm.emailAddress" type="Email" id="emailAddress" name="emailAddress" maxlength="254" class="form-control" value="">
        </div>

        <div class="form-item">
          <label for="phone" class="marg-top-small">Phone number*</label>
          <input [(ngModel)]="registrationForm.contactDetails.phone" type="text" id="phone" name="phone" maxlength="20" class="form-control" value="">
        </div>

<!--        <div class="form-item">-->
<!--          <label for="phone" class="marg-top-small">What event do you want to attend?*</label>-->

<!--          <div>-->
<!--            <div>-->
<!--              <label>-->
<!--                <input type="checkbox" class="bbcheckbox" name="accessCode" [(ngModel)]="participations.virtual" />-->
<!--                Virtual Event-->
<!--              </label>-->
<!--            </div>-->
<!--            <div>-->
<!--              <label>-->
<!--                <input type="checkbox" class="bbcheckbox" name="accessCode" [(ngModel)]="participations.faceToFace" />-->
<!--                Face-to-face Event-->
<!--              </label>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

        <div class="form-item">
          <label for="Country" class="marg-top-small">Country*</label>
          <select [(ngModel)]="country" id="Country" name="Country" class="dropdownz form-control">
            <option value="" selected="" disabled="">Please select</option>
            <option value="AU">Australia</option>
            <option value="NZ">New Zealand</option>
          </select>
        </div>

        <div class="form-item">
          <label for="company" class="marg-top-small">Practice/Organisation*</label>
          <input [(ngModel)]="registrationForm.contactDetails.company" type="text" id="company" name="company" maxlength="254" class="form-control" value="">
        </div>

        <div class="form-item">
          <label for="Profession" class="marg-top-small">Where you predominantly work:*</label>
          <select [(ngModel)]="registrationForm.contactDetails.ownedBy" name="Profession" id="Profession" class="dropdownz form-control state">
            <option disabled="" selected="" value="">select one option</option>
            <option value="In the industry">In the industry</option>
            <option value="In the hospital">In the hospital</option>
            <option value="In a specialised Diabetes Service">In a specialised Diabetes Service</option>
            <option value="In Community Health">In Community Health</option>
            <option value="In General Practice">In General Practice</option>
            <option value="In the Community">In the Community</option>
            <option value="In Specialist Private Practice">In Specialist Private Practice</option>
          </select>
        </div>

        <div class="form-item">
          <label for="postcode" class="marg-top-small">Postcode*</label>
          <input [(ngModel)]="registrationForm.contactDetails.postCode" type="text" id="postcode" name="postcode" maxlength="254" class="form-control" value="">
        </div>

        <div class="form-item">
          <label for="Profession" class="marg-top-small">Job Title*</label>
          <select [(ngModel)]="roleSelection.role" name="Profession" id="Profession" class="dropdownz form-control state">
            <option disabled="" selected="" value="">select one option</option>
<!--            <option value="Industry">Industry</option>-->
            <option value="General Practitioner">General Practitioner</option>
            <option value="Community Nurse">Community Nurse</option>
            <option value="Dietitian">Dietitian</option>
            <option value="Podiatrist">Podiatrist</option>
            <option value="Exercise physiologist">Exercise physiologist</option>
            <option value="Optometrist">Optometrist</option>
            <option value="Specialist Physician">Specialist Physician</option>
            <option value="Nurse Practitioner">Nurse Practitioner</option>
            <option value="JMO">JMO</option>
            <option value="Diabetes Educator">Diabetes Educator</option>
            <option value="Psychologist">Psychologist</option>
            <option value="Pharmacist">Pharmacist</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div class="form-item" [hidden]="roleSelection.role !== 'Other'">
          <label for="otherProfession" class="marg-top-small">Other Job Title*</label>
          <input [(ngModel)]="roleSelection.otherRole" type="text" id="otherProfession" name="otherProfession" maxlength="254" class="form-control" value="">
        </div>

        <br>

        <div class="row">
            <div class="col-sm-3 col-lg-2">
                <img class="mi-logo" src="assets/images/myINTERACT_appicon.png">
            </div>
            <div class="col-sm-9 col-lg-10">
                <p>
                  myINTERACT will provide you with easy to access information and virtual webinar links during the Western Sydney Diabetes Masterclass 2024.
                </p>
                <p>
                    The registration process will automatically create an account on
                    myINTERACT which requires a password.<br> Please enter a password below.
                    (Password needs to be 8 characters long, including 1 number, 1 lowercase
                    letter and 1 capital letter). <br>
                </p>
                <p>
                    If you already have a myINTERACT account enter your existing password.
                    Forgot password? <a href="https://myfiles.interact.technology/interact/#/resetPassword" style="color:#000; font-weight:bold; text-decoration:underline;" target="_blank">Click here</a>
                </p>
            </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <label for="Password" class="marg-top-small">Create password / Enter your existing password*:</label>
            <span style="margin-left:40px;"><p style="display: inline-block;">Forgot password? <a href="https://myfiles.interact.technology/interact/#/resetPassword" style="color:#000; font-weight:bold; text-decoration:underline;" target="_blank">Click here</a></p></span>
            <input [(ngModel)]="registrationForm.password" type="password" id="Password" maxlength="30" name="Password" class="form-control">

            <label for="ConfirmPassword" class="marg-top-small">Confirm password*:</label>
            <input [(ngModel)]="confirmPassword" type="password" id="ConfirmPassword" maxlength="30" name="ConfirmPassword" class="form-control"><br>
          </div>
          <div class="col-sm-6">
            <div class="form-group center-block top-buffer">
              <label for="" class="marg-top-small">Verification*</label><br><br>


              <re-captcha (resolved)="resolved($event)" siteKey="{{recaptchaKey}}"></re-captcha>
              <p class="error help-block small"></p>
            </div>
          </div>
        </div>


        <div class="row check-box-margin">
          <div class="col-sm-12">
            <div class="checkbox-container">
              <input type="checkbox" id="interactAgree" class="bbcheckbox" name="interactAgree" [(ngModel)]="interactAgree" value="I agree">
              <label for="interactAgree" class="checktext2">
              I agree to INTERACT's <a class="click-link" href="https://s3-us-west-1.amazonaws.com/interact.technology/legal/internet-services/au/EULA.html" target="_blank">Terms & Conditions</a> and <a class="click-link" href="https://www.interact.technology/privacy" target="_blank">Privacy Policy</a>*
            </label>
          </div>
        </div>
      </div>

        <div class="row text-center">
          <div class="col-12">
            <button name="submit" class="btn btn-lg submit-button" (click)="submit()">Submit</button>
          </div>
        </div>
        <div class="text-center" style="margin-top:25px; margin-bottom: 25px;">For registration or webcast technical questions, please contact myINTERACT on: <a class="click-link" href="mailto:support@interact.technology">support@interact.technology</a></div>
      </form>
    </div>
    <div class="form-container white-background">
      <form>
        <div class="spinner-overlay" [hidden]="!loading">
          <div class="loading-spinner-circle"></div>
        </div>
      </form>
    </div>


    <div class="col-xs-12 no-pad bottom-blue-container text-center">
      www.westernsydneydiabetes.com.au
    </div>
  </div>
</div>
